var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orders.length
    ? _c("table", { staticClass: "table small table-hover oc-table" }, [
        _c("thead", [
          _c(
            "tr",
            [
              _c("th", { staticClass: "min-width td-icon" }),
              _vm._v(" "),
              _vm._l(_vm.settings.backend_fields_sorted, function(
                setting,
                index
              ) {
                return [
                  !!+_vm.settings.backend_fields[setting]
                    ? [
                        setting == "id"
                          ? _c(
                              "th",
                              { staticClass: "min-width text-center td-id" },
                              [_vm._v("ID")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        setting == "status"
                          ? _c("th", [_vm._v("Статус")])
                          : _vm._e(),
                        _vm._v(" "),
                        setting == "region"
                          ? _c("th", [_vm._v("Регион")])
                          : _vm._e(),
                        _vm._v(" "),
                        setting == "contacts"
                          ? _c(
                              "th",
                              { staticStyle: { "padding-left": "40px" } },
                              [_vm._v("Контакт")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        setting == "url"
                          ? _c(
                              "th",
                              { staticStyle: { "padding-left": "40px" } },
                              [_vm._v("Страница заявки")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        setting == "items"
                          ? _c("th", { staticClass: "text-center" }, [
                              _vm._v("Товары в корзине")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        setting == "date"
                          ? _c("th", [_vm._v("Дата")])
                          : _vm._e(),
                        _vm._v(" "),
                        setting == "topic"
                          ? _c("th", [_vm._v("Тема")])
                          : _vm._e(),
                        _vm._v(" "),
                        setting == "comment"
                          ? _c("th", [_vm._v("Комментарий")])
                          : _vm._e(),
                        _vm._v(" "),
                        setting == "time"
                          ? _c("th", [_vm._v("Время для звонка")])
                          : _vm._e(),
                        _vm._v(" "),
                        setting == "checkboxes"
                          ? _c("th", [_vm._v("Чекбоксы")])
                          : _vm._e()
                      ]
                    : _vm._e()
                ]
              }),
              _vm._v(" "),
              _c("th")
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.orders, function(order) {
            return _c(
              "tr",
              { key: order.id, class: "oc-status-" + order.status },
              [
                _c("td", { staticClass: "min-width td-icon" }),
                _vm._v(" "),
                _vm._l(_vm.settings.backend_fields_sorted, function(
                  setting,
                  index
                ) {
                  return [
                    !!+_vm.settings.backend_fields[setting]
                      ? [
                          setting == "id"
                            ? _c("td", { staticClass: "td-id" }, [
                                _vm._v(_vm._s(order.id))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          setting == "status"
                            ? _c("status-field", {
                                attrs: {
                                  order: order,
                                  "backend-status": _vm.settings.backend_status
                                },
                                on: {
                                  change: function(status) {
                                    _vm.setStatus(order, status)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          setting == "region"
                            ? _c("region-field", { attrs: { order: order } })
                            : _vm._e(),
                          _vm._v(" "),
                          setting == "contacts"
                            ? _c("contacts-field", { attrs: { order: order } })
                            : _vm._e(),
                          _vm._v(" "),
                          setting == "url"
                            ? _c("url-field", { attrs: { order: order } })
                            : _vm._e(),
                          _vm._v(" "),
                          setting == "items"
                            ? _c("items-field", {
                                attrs: { order: order },
                                on: {
                                  click: function($event) {
                                    return _vm.$emit("openItems", order)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          setting == "date"
                            ? _c("date-field", { attrs: { order: order } })
                            : _vm._e(),
                          _vm._v(" "),
                          setting == "topic"
                            ? _c("topic-field", { attrs: { order: order } })
                            : _vm._e(),
                          _vm._v(" "),
                          setting == "comment"
                            ? _c("comment-field", { attrs: { order: order } })
                            : _vm._e(),
                          _vm._v(" "),
                          setting == "time"
                            ? _c("time-field", { attrs: { order: order } })
                            : _vm._e(),
                          _vm._v(" "),
                          setting == "checkboxes"
                            ? _c("checkboxes-field", {
                                attrs: { order: order }
                              })
                            : _vm._e()
                        ]
                      : _vm._e()
                  ]
                }),
                _vm._v(" "),
                _c("td", { staticClass: "td-delete" }, [
                  _c(
                    "a",
                    {
                      staticClass: "oc-delete-order",
                      attrs: {
                        href: "#",
                        "data-toggle": "modal",
                        "data-target": "#deleteModal",
                        title: "Удалить"
                      },
                      on: {
                        click: function($event) {
                          return _vm.deleteOrder(order)
                        }
                      }
                    },
                    [_c("i", { staticClass: "oc-icon16 ico-delete" })]
                  )
                ])
              ],
              2
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7db4df0d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db4df0d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/components/table/Table.vue
// module id = 193
// module chunks = 1